import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface LinkablePlace {
  id: string;
  name: string;
  municipality: string | null;
  landskap: string | null;
  status: string;
}

export function useSearchPlacesForLinking(query: string = '') {
  return useQuery<LinkablePlace[]>({
    queryKey: ['places-for-linking', query],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('search_places_for_linking', {
        p_query: query,
        p_limit: 30,
      });
      if (error) throw error;
      return (data ?? []) as LinkablePlace[];
    },
    staleTime: 30_000,
  });
}
